module.exports = __webpack_public_path__ + "static/img/before_eight.79abe6b8.png";